// extracted by mini-css-extract-plugin
export default {"div_container":"InputWithText_div_container__262vp","border_red":"InputWithText_border_red__HR6mH"};